import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const services = ['Kasetli Tente', 'Bioklimatik Pergola', 'Zip Perde', 'Şeffaf Branda', 'Otomatik Pergola', 'Körüklü Tente'];

export default function HeroSection() {
  const [visible, setVisible] = useState(false);
  const [activeService, setActiveService] = useState(0);

  useEffect(() => {
    const t = setTimeout(() => setVisible(true), 80);
    return () => clearTimeout(t);
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveService((prev) => (prev + 1) % services.length);
    }, 2200);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="relative min-h-screen bg-[#0f1923] flex flex-col">
      <h1 className="sr-only">İzmir&apos;de Tenteci — Tente, Pergola ve Branda Sistemleri</h1>

      {/* Background image — right half */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute right-0 top-0 w-full md:w-3/5 h-full">
          <img
            src="/images/pages/hero-pergola.webp"
            alt="İzmir Tente Pergola ve Dış Mekan Sistemleri"
            className="w-full h-full object-cover object-center"
            loading="eager" fetchpriority="high" decoding="async"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0f1923] via-[#0f1923]/70 to-transparent"></div>
          <div className="absolute inset-0 bg-gradient-to-t from-[#0f1923]/60 via-transparent to-[#0f1923]/30"></div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 flex-1 flex items-center">
        <div className="max-w-7xl mx-auto px-6 md:px-10 w-full pt-28 pb-16">
          <div className={`max-w-xl transition-all duration-1000 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>

            {/* Tag */}
            <div className="inline-flex items-center gap-2 bg-[#d4a853]/15 border border-[#d4a853]/30 px-4 py-2 rounded-full mb-8">
              <span className="w-1.5 h-1.5 bg-[#d4a853] rounded-full"></span>
              <span className="font-body text-[#d4a853] text-xs font-medium tracking-widest uppercase">İzmir&apos;in Tente Uzmanı</span>
            </div>

            {/* Heading */}
            <h2 className="font-heading text-5xl md:text-6xl lg:text-7xl text-white leading-[1.05] mb-4">
              Dış Mekanınız <br />
              <span className="text-[#d4a853] italic">Yeniden Doğsun</span>
            </h2>

            {/* Rotating service */}
            <div className="flex items-center gap-3 mb-6 h-8">
              <div className="w-5 h-px bg-[#d4a853]/60"></div>
              <span className="font-body text-white/50 text-sm">Şu an:</span>
              <span className="font-body text-[#d4a853] text-sm font-medium transition-all duration-500">
                {services[activeService]}
              </span>
            </div>

            <p className="font-body text-white/55 text-base leading-relaxed mb-10 max-w-md">
              Kasetli tenteden bioklimatik pergolaya, zip perdeden şeffaf brandaya — İzmir ve tüm ilçelerde ücretsiz keşif, uzman montaj.
            </p>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-3 mb-12">
              <a
                href="tel:05362771709"
                className="inline-flex items-center justify-center gap-2 bg-[#d4a853] text-[#0f1923] font-body font-semibold px-7 py-4 rounded-lg hover:bg-[#e8c47a] transition-colors cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-phone-fill"></i>
                Ücretsiz Keşif İçin Ara
              </a>
              <a
                href="https://wa.me/905362771709"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="inline-flex items-center justify-center gap-2 border border-white/20 text-white font-body font-medium px-7 py-4 rounded-lg hover:border-[#d4a853] hover:text-[#d4a853] transition-all cursor-pointer whitespace-nowrap text-sm"
              >
                <i className="ri-whatsapp-fill"></i>
                WhatsApp&apos;tan Yaz
              </a>
            </div>

            {/* Stats */}
            <div className="flex items-center gap-8 pt-8 border-t border-white/10">
              {[
                { val: '500+', lbl: 'Proje' },
                { val: '10+', lbl: 'Yıl' },
                { val: '11', lbl: 'Sistem' },
                { val: '10', lbl: 'İlçe' },
              ].map((s) => (
                <div key={s.lbl}>
                  <div className="font-heading text-2xl text-[#d4a853]">{s.val}</div>
                  <div className="font-body text-white/40 text-xs mt-0.5">{s.lbl}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom service pills */}
      <div className="relative z-10 border-t border-white/8">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center gap-2 overflow-x-auto scrollbar-hide">
          <span className="font-body text-white/30 text-xs whitespace-nowrap mr-2">Hizmetler:</span>
          {services.map((s) => (
            <Link
              key={s}
              to={`/hizmetler/${s.toLowerCase().replace(/\s+/g, '-').replace(/ı/g, 'i').replace(/ş/g, 's').replace(/ğ/g, 'g').replace(/ü/g, 'u').replace(/ö/g, 'o').replace(/ç/g, 'c')}`}
              className="font-body text-xs text-white/50 hover:text-[#d4a853] border border-white/10 hover:border-[#d4a853]/40 px-3 py-1.5 rounded-full whitespace-nowrap transition-all cursor-pointer"
            >
              {s}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
